<button [ngClass]="disabled ? ( disableButtonClass || 'disabledBtn') : (typeBtn? [buttonClass, 'custButtonClass'] : buttonClass)" type="{{type}}" [disabled]="disabled"
  (click)="onClickEvent($event)">
  @if (!loadingIcon) {
    <span>
      @if (isImg) {
        <img class="img-google" src="{{isImg}}" alt="">
      }
      {{buttonLabel}}
    </span>
  }
  @if (loadingIcon) {
    <span>
      <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
    </span>
  }
</button>
